import PlateGrid from './PlateGrid';

export default function NewPlateTemplateSection({state,creationArgs={},setCreationArgs}){

  let experimentId = "e0";
  let { e0 } = state.experiments;

  let selectedTemplate = creationArgs?.template
  


  let grids = Object.entries(e0.grids).map(([gridId,grid]) => {

    let isSelected = selectedTemplate && (
    selectedTemplate.gridId === gridId && selectedTemplate.experimentId === experimentId

  )

    return (
      <div onClick={() => {


        let subList = grid.flat().flat().map(liquid => {
          return liquid.substance 
        })

        let substances = Array.from( new Set(subList) );


        setCreationArgs({

          template:{
            experimentId,
            gridId,
          },
          substances,
          variableMap:state.experiments[experimentId].variableMap,
          evaluation:{}

        })



      }} class={`rel hoverable`} style={{border:'2px solid #ccc', width:100, padding: 5, margin:5}}>

        <div style={{ }} class="npe"><PlateGrid {...{
          grid, experiment:e0, gridId,
          hoverMap:{},
          showHeadings:false,
          showText:false,

        }}/></div>

        {isSelected && (
          <div class="selected-item-cover"/>
        )}
      </div>
    )

  })

  let gridToShow;
  if( creationArgs.template ){
    let { gridId } = creationArgs.template;

    let experiment = state.experiments[experimentId];
    let grid = experiment.grids[gridId];

    gridToShow = (
      <div class="npe">
      <PlateGrid {...{
        grid,
        experiment,
        gridId,
        showHeadings:false,
        showText:{value:true}
      }}/>
      </div>
    )



  }

  return (
    <div class="fair-margin">

      <h5>Templates</h5>

      <div class="sg-row rel">
        <div style={{flexWrap:'wrap'}} 
          class="sg-row half">
          {grids}
        </div>
        <div style={{border:'1px solid #ccc'}} class="half full-height">

          {false && <div>{JSON.stringify(creationArgs)}</div>}
          {creationArgs?.template && (
            <div>
              {gridToShow}
            </div>
          )}


        </div>

      </div>

    </div>
  )

}
